"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = require("react-jss");

var LockedstylesWithProps = function LockedstylesWithProps(props) {
  return {
    FieldSet: {
      // border: null,
      // border: props.variant === "outlined" ? null : "0 none"
      // padding: props.variant === "outlined" ? "0px 0px 0px 0px" : "0px"
      padding: props.InputType === "Select" ? "0px" : "0px 0px 0px 8px"
    }
  };
};

var Lockedstyles = {
  FormElement: {
    display: "flex",
    flexDirection: "column"
  },
  FormInput: {
    display: "flex",
    position: "relative",
    alignItems: "center",
    boxSizing: "border-box"
  },
  FieldSet: {
    top: "-5px",
    left: "0px",
    right: "0px",
    width: "100%",
    margin: "0px",
    boxSizing: "border-box"
  }
};
var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    FormElement: theme.FormTextInput.FormElement,
    FormInput: theme.FormTextInput.FormInput,
    FieldSet: function FieldSet(props) {
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.BoderRadius ? props.BorderStyle.BoderRadius : null : null;

      if (props.variant === "outlined") {
        if (BorderStyleFinal) {
          return {
            borderRadius: BorderStyleFinal
          };
        } else {
          return theme.FormTextInput.FieldSet;
        }
      } else {
        return null;
      }
    },
    FieldSetStandard: {
      // position: "relative",
      top: "-5px",
      left: "0px",
      right: "0px",
      width: "100%",
      margin: "0px",
      // pointerEvents: "none ",
      padding: "0px 0px 0px 8px",
      boxSizing: "border-box",
      borderBottom: "1px solid transparent",
      borderTop: "0 none",
      borderLeft: "0 none",
      borderRight: "0 none",
      "&:hover $HoverBorderHovered": {
        visibility: "visible"
      }
    },
    StandardInputBorder: {
      position: "absolute",
      bottom: "-1px",
      boxSizing: "border-box",
      left: "0px",
      right: "0px",
      content: '""'
    },
    BorderEmpty: function BorderEmpty(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Empty ? props.Colors.Empty : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Empty ? props.BorderStyle.Empty : null : null;

      if (props.variant !== "outlined") {
        if (BorderStyleFinal) {
          return {
            borderBottom: BorderStyleFinal
          };
        } else if (BorderColorFinal) {
          return {
            borderBottom: "1px solid ".concat(BorderColorFinal)
          };
        } else {
          return theme.FormTextInput.FieldSetBorderEmpty;
        }
      } else {
        return null;
      }
    },
    BorderFilled: function BorderFilled(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Filled ? props.Colors.Filled : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Filled ? props.BorderStyle.Filled : null : null;

      if (props.variant !== "outlined") {
        if (BorderStyleFinal) {
          return {
            borderBottom: BorderStyleFinal
          };
        } else if (BorderColorFinal) {
          return {
            borderBottom: "1px solid ".concat(BorderColorFinal)
          };
        } else {
          return theme.FormTextInput.FieldSetBorderFilled;
        }
      } else {
        return null;
      }
    },
    BorderDisabled: function BorderDisabled(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Disabled ? props.Colors.Disabled : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Disabled ? props.BorderStyle.Disabled : null : null;

      if (props.variant !== "outlined") {
        if (BorderStyleFinal) {
          return {
            border: BorderStyleFinal
          };
        } else if (BorderColorFinal) {
          return {
            border: "1px solid ".concat(BorderColorFinal)
          };
        } else {
          return theme.FormTextInput.FieldSetBorderDisabled;
        }
      } else {
        return null;
      }
    },
    FocusBorderHidden: {
      transform: "scaleX(0)",
      transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
    },
    FocusBorderFocused: {
      transform: "scaleX(1)",
      transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
    },
    HoverBorderHovered: function HoverBorderHovered(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Filled ? props.Colors.Filled : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Filled ? props.BorderStyle.Filled : null : null;

      if (BorderStyleFinal) {
        return {
          borderBottom: "2px solid borderBottom: ".concat(BorderStyleFinal),
          visibility: "hidden"
        };
      } else if (BorderColorFinal) {
        return {
          borderBottom: "2px solid borderBottom: ".concat(BorderColorFinal),
          visibility: "hidden"
        };
      } else {
        return {
          borderBottom: theme.FormTextInput.FieldSetBorderHover.borderBottom,
          visibility: "hidden"
        };
      }
    },
    ErrorBorder: function ErrorBorder(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Error ? props.Colors.Error : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Error ? props.BorderStyle.Error : null : null;

      if (props.variant !== "outlined") {
        if (BorderStyleFinal) {
          return {
            borderBottom: BorderStyleFinal
          };
        } else if (BorderColorFinal) {
          return {
            borderBottom: "2px solid ".concat(BorderColorFinal)
          };
        } else {
          return theme.FormTextInput.FieldSetBorderError;
        }
      } else {
        return null;
      }
    },
    FieldSetOutlinedBorderEmpty: function FieldSetOutlinedBorderEmpty(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Empty ? props.Colors.Empty : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Empty ? props.BorderStyle.Empty : null : null;

      if (props.variant === "outlined") {
        if (BorderStyleFinal) {
          return {
            border: BorderStyleFinal
          };
        } else if (BorderColorFinal) {
          return {
            border: "1px solid ".concat(BorderColorFinal)
          };
        } else {
          return theme.FormTextInput.FieldSetOutlinedBorderEmpty;
        }
      } else {
        return null;
      }
    },
    FieldSetOutlinedBorderFocus: function FieldSetOutlinedBorderFocus(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Focused ? props.Colors.Focused : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Focused ? props.BorderStyle.Focused : null : null;

      if (props.variant === "outlined") {
        if (BorderStyleFinal) {
          return {
            border: BorderStyleFinal
          };
        } else if (BorderColorFinal) {
          return {
            border: "1px solid ".concat(BorderColorFinal)
          };
        } else {
          return theme.FormTextInput.FieldSetOutlinedBorderFocus;
        }
      } else {
        return null;
      }
    },
    FieldSetOutlinedBorderError: function FieldSetOutlinedBorderError(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Error ? props.Colors.Error : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Error ? props.BorderStyle.Error : null : null;

      if (props.variant === "outlined") {
        if (BorderStyleFinal) {
          return {
            border: BorderStyleFinal
          };
        } else if (BorderColorFinal) {
          return {
            border: "1px solid ".concat(BorderColorFinal)
          };
        } else {
          return theme.FormTextInput.FieldSetOutlinedBorderError;
        }
      } else {
        return null;
      }
    },
    FieldSetOutlinedBorderFilled: function FieldSetOutlinedBorderFilled(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Filled ? props.Colors.Filled : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Filled ? props.BorderStyle.Filled : null : null;

      if (props.variant === "outlined") {
        if (BorderStyleFinal) {
          return {
            border: BorderStyleFinal
          };
        } else if (BorderColorFinal) {
          return {
            border: "1px solid ".concat(BorderColorFinal)
          };
        } else {
          return theme.FormTextInput.FieldSetOutlinedBorderFilled;
        }
      } else {
        return null;
      }
    },
    FieldSetOutlinedBorderDisabled: function FieldSetOutlinedBorderDisabled(props) {
      var BorderColorFinal = props.Colors ? props.Colors.Disabled ? props.Colors.Disabled : null : null;
      var BorderStyleFinal = props.BorderStyle ? props.BorderStyle.Disabled ? props.BorderStyle.Disabled : null : null;

      if (props.variant === "outlined") {
        if (BorderStyleFinal) {
          return {
            border: BorderStyleFinal
          };
        } else if (BorderColorFinal) {
          return {
            border: "1px solid ".concat(BorderColorFinal)
          };
        } else {
          return theme.FormTextInput.FieldSetOutlinedBorderDisabled;
        }
      } else {
        return null;
      }
    },
    Legend: function Legend(props) {
      if (props.InputType === "Select") {
        //No Animation of the legend
        return {
          display: "block",
          padding: "0",
          textAlign: "left",
          width: "auto",
          visibility: "hidden",
          maxWidth: "0.01px",
          // when lable is at the bottom
          marginLeft: "8px"
        };
      } else {
        return {
          display: "block",
          padding: "0",
          textAlign: "left",
          width: "auto",
          visibility: "hidden",
          maxWidth: "0.01px",
          // when lable is at the bottom
          transition: "max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms"
        };
      }
    },
    LegendTop: function LegendTop(props) {
      if (props.InputType === "Select") {
        //No Animation of the legend
        return {
          maxWidth: "1000px"
        };
      } else {
        return {
          maxWidth: "1000px",
          transition: "max-width  100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms"
        };
      }
    },
    LegendSpan: {
      visibility: "hidden",
      padding: "0px 5px 0px 5px"
    },
    Label: function Label(props) {
      if (props.InputType === "Select") {
        //No Animation of the legend
        return {
          position: "absolute",
          padding: "0px",
          margin: "0px",
          transformOrigin: "top left",
          top: "0px",
          left: "0px",
          pointerEvents: "none "
        };
      } else {
        return {
          position: "absolute",
          padding: "0px",
          margin: "0px",
          transformOrigin: "top left",
          top: "0px",
          left: "0px",
          pointerEvents: "none",
          // lineHeight: "18px",
          // fontWeight: "400",
          // transform: "scale(1) translate(12px, 20px) translateX(0px) translateY(0px)", //When in the middle
          transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
        };
      }
    },
    LabelEmpty: function LabelEmpty(props) {
      var LabelColorFinal = props.Colors ? props.Colors.Empty ? props.Colors.Empty : null : null;
      var LabelStyleFinal = props.Colors ? props.LabelStyle.Empty ? props.LabelStyle.Empty : null : null;

      if (props.InputType === "Select") {
        if (LabelStyleFinal) {
          return {
            color: LabelStyleFinal
          };
        } else if (LabelColorFinal) {
          return {
            color: LabelColorFinal
          };
        } else {
          return {
            color: theme.FormTextInput.LabelEmpty.color
          };
        }
      } else {
        if (LabelStyleFinal) {
          return {
            color: LabelStyleFinal,
            transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          };
        } else if (LabelColorFinal) {
          return {
            color: LabelColorFinal,
            transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          };
        } else {
          return {
            color: theme.FormTextInput.LabelEmpty.color,
            transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          };
        }
      }
    },
    LabelPlaceHolderEmpty: function LabelPlaceHolderEmpty(props) {
      var LabelColorFinal = props.Colors ? props.Colors.Empty ? props.Colors.Empty : null : null;
      var LabelStyleFinal = props.Colors ? props.LabelStyle.Empty ? props.LabelStyle.Empty : null : null;

      if (props.InputType === "Select") {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              pointerEvents: "none "
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              pointerEvents: "none "
            };
          } else {
            return {
              color: theme.FormTextInput.LabelPlaceHolderEmpty.color,
              transform: "scale(0.75) translate(13px, 0px)",
              pointerEvents: "none "
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              pointerEvents: "none "
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              pointerEvents: "none "
            };
          } else {
            return {
              color: theme.FormTextInput.LabelPlaceHolderEmpty.color,
              transform: "scale(0.75) translate(0px, 0px)",
              pointerEvents: "none "
            };
          }
        }
      } else {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
              pointerEvents: "none "
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
              pointerEvents: "none "
            };
          } else {
            return {
              color: theme.FormTextInput.LabelPlaceHolderEmpty.color,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
              pointerEvents: "none "
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
              pointerEvents: "none "
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
              pointerEvents: "none "
            };
          } else {
            return {
              color: theme.FormTextInput.LabelPlaceHolderEmpty.color,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
              pointerEvents: "none "
            };
          }
        }
      }
    },
    LabelFilled: function LabelFilled(props) {
      var LabelColorFinal = props.Colors ? props.Colors.Empty ? props.Colors.Empty : null : null;
      var LabelStyleFinal = props.Colors ? props.LabelStyle.Empty ? props.LabelStyle.Empty : null : null;

      if (props.InputType === "Select") {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelFilled.color,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelFilled.color,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          }
        }
      } else {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelFilled.color,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelFilled.color,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          }
        }
      }
    },
    LabelFocus: function LabelFocus(props) {
      var LabelColorFinal = props.Colors ? props.Colors.Focused ? props.Colors.Focused : null : null;
      var LabelStyleFinal = props.Colors ? props.LabelStyle.Focused ? props.LabelStyle.Focused : null : null;

      if (props.InputType === "Select") {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelFocus.color,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelFocus.color,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          }
        }
      } else {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelFocus.color,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelFocus.color,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          }
        }
      }
    },
    LabelErrorEmpty: function LabelErrorEmpty(props) {
      var LabelColorFinal = props.Colors ? props.Colors.Error ? props.Colors.Error : null : null;
      var LabelStyleFinal = props.Colors ? props.LabelStyle.Error ? props.LabelStyle.Error : null : null;

      if (props.InputType === "Select") {
        if (LabelStyleFinal) {
          return {
            color: LabelStyleFinal
          };
        } else if (LabelColorFinal) {
          return {
            color: LabelColorFinal
          };
        } else {
          return {
            color: theme.FormTextInput.LabelError.color
          };
        }
      } else {
        if (LabelStyleFinal) {
          return {
            color: LabelStyleFinal,
            transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          };
        } else if (LabelColorFinal) {
          return {
            color: LabelColorFinal,
            transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          };
        } else {
          return {
            color: theme.FormTextInput.LabelError.color,
            transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          };
        }
      }
    },
    LabelError: function LabelError(props) {
      var LabelColorFinal = props.Colors ? props.Colors.Error ? props.Colors.Error : null : null;
      var LabelStyleFinal = props.Colors ? props.LabelStyle.Error ? props.LabelStyle.Error : null : null;

      if (props.InputType === "Select") {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelError.color,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelError.color,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          }
        }
      } else {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelError.color,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelError.color,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          }
        }
      }
    },
    LabelDisabledEmpty: function LabelDisabledEmpty(props) {
      var LabelColorFinal = props.Colors ? props.Colors.Disabled ? props.Colors.Disabled : null : null;
      var LabelStyleFinal = props.Colors ? props.LabelStyle.Disabled ? props.LabelStyle.Disabled : null : null;

      if (props.InputType === "Select") {
        if (LabelStyleFinal) {
          return {
            color: LabelStyleFinal
          };
        } else if (LabelColorFinal) {
          return {
            color: LabelColorFinal
          };
        } else {
          return {
            color: theme.FormTextInput.LabelDisabledEmpty
          };
        }
      } else {
        if (LabelStyleFinal) {
          return {
            color: LabelStyleFinal,
            transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          };
        } else if (LabelColorFinal) {
          return {
            color: LabelColorFinal,
            transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          };
        } else {
          return {
            color: theme.FormTextInput.LabelDisabledEmpty,
            transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
          };
        }
      }
    },
    LabelDisabled: function LabelDisabled(props) {
      var LabelColorFinal = props.Colors ? props.Colors.Disabled ? props.Colors.Disabled : null : null;
      var LabelStyleFinal = props.Colors ? props.LabelStyle.Disabled ? props.LabelStyle.Disabled : null : null;

      if (props.InputType === "Select") {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelDisabled.color,
              transform: "scale(0.75) translate(13px, 0px)"
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelDisabled.color,
              transform: "scale(0.75) translate(0px, 0px)"
            };
          }
        }
      } else {
        if (props.variant === "outlined") {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelDisabled.color,
              transform: "scale(0.75) translate(13px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          }
        } else {
          if (LabelStyleFinal) {
            return {
              color: LabelStyleFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else if (LabelColorFinal) {
            return {
              color: LabelColorFinal,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          } else {
            return {
              color: theme.FormTextInput.LabelDisabled.color,
              transform: "scale(0.75) translate(0px, 0px)",
              transition: "transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
            };
          }
        }
      }
    },
    LabelSpan: {
      padding: "0px 5px 0px 5px"
    },
    Input: {
      display: "block",
      // borderRadius: "3px",
      border: "0px ",
      backgroundColor: "transparent",
      boxSizing: "border-box",
      pointerEvents: "all",
      //Keep it here to set the full component height to harmonize with other inputs
      // minHeight: "25px",
      // lineHeight: "25px",
      // height: "30px"
      webkitAppearance: "none ",
      outline: "none ",
      background: "none",
      "&:error": {
        webkitAppearance: "none ",
        outline: "none ",
        border: "none ",
        boxShadow: "none"
      },
      "&:invalid": {
        outline: "none ",
        border: "none ",
        boxShadow: "none "
      },
      "&:focus": {
        webkitAppearance: "none ",
        outline: "none ",
        border: "none ",
        boxShadow: "none"
      },
      "&:active": {
        webkitAppearance: "none ",
        outline: "none ",
        border: "none ",
        boxShadow: "none"
      }
    },
    InputFont: theme.FormTextInput.InputFont,
    InputColorFilled: function InputColorFilled(props) {
      var ColorFinal = props.Colors ? props.Colors.Filled ? props.Colors.Filled : null : null;
      var InputStyleFinal = props.InputStyle ? props.InputStyle.Filled ? props.InputStyle.Filled : null : null;

      if (InputStyleFinal) {
        return {
          color: InputStyleFinal
        };
      } else if (ColorFinal) {
        return {
          color: ColorFinal
        };
      } else {
        return {
          color: theme.FormTextInput.InputColor.color
        };
      }
    },
    InputColor: function InputColor(props) {
      var ColorFinal = props.Colors ? props.Colors.Filled ? props.Colors.Filled : null : null;
      var InputStyleFinal = props.InputStyle ? props.InputStyle.Filled ? props.InputStyle.Filled : null : null;

      if (InputStyleFinal) {
        return {
          color: InputStyleFinal
        };
      } else if (ColorFinal) {
        return {
          color: ColorFinal
        };
      } else {
        return {
          color: theme.FormTextInput.InputColor.color
        };
      }
    },
    InputColorFocus: function InputColorFocus(props) {
      var ColorFinal = props.Colors ? props.Colors.Focused ? props.Colors.Focused : null : null;
      var InputStyleFinal = props.InputStyle ? props.InputStyle.Focused ? props.InputStyle.Focused : null : null;

      if (InputStyleFinal) {
        return {
          color: InputStyleFinal
        };
      } else if (ColorFinal) {
        return {
          color: ColorFinal
        };
      } else {
        return {
          color: theme.FormTextInput.InputColorFocus.color
        };
      }
    },
    InputColorError: function InputColorError(props) {
      var ColorFinal = props.Colors ? props.Colors.Error ? props.Colors.Error : null : null;
      var InputStyleFinal = props.InputStyle ? props.InputStyle.Error ? props.InputStyle.Error : null : null;

      if (InputStyleFinal) {
        return {
          color: InputStyleFinal
        };
      } else if (ColorFinal) {
        return {
          color: ColorFinal
        };
      } else {
        return {
          color: theme.FormTextInput.InputColorError.color
        };
      }
    },
    InputColorDisabled: function InputColorDisabled(props) {
      var ColorFinal = props.Colors ? props.Colors.Disabled ? props.Colors.Disabled : null : null;
      var InputStyleFinal = props.InputStyle ? props.InputStyle.Disabled ? props.InputStyle.Disabled : null : null;

      if (InputStyleFinal) {
        return {
          color: InputStyleFinal
        };
      } else if (ColorFinal) {
        return {
          color: ColorFinal
        };
      } else {
        return {
          color: theme.FormTextInput.InputColorDisabled.color
        };
      }
    },
    BottomMessageContent: theme.FormTextInput.BottomMessageContent,
    BottomMessageContentError: function BottomMessageContentError(props) {
      var ErrorStyleFinal = props.ErrorStyle ? props.ErrorStyle.color ? props.ErrorStyle.color : null : null;
      var ColorFinal = props.Colors ? props.Colors.Error ? props.Colors.Error : null : null;

      if (ErrorStyleFinal) {
        return {
          color: ErrorStyleFinal
        };
      } else if (ColorFinal) {
        return {
          color: ColorFinal
        };
      } else {
        return theme.FormTextInput.BottomMessageContentError;
      }
    },
    BottomMessageContentHelper: function BottomMessageContentHelper(props) {
      var ColorFinal = props.HelperStyle ? props.HelperStyle.color ? props.HelperStyle.color : null : null;

      if (ColorFinal) {
        return {
          color: ColorFinal
        };
      } else {
        return theme.FormTextInput.BottomMessageContentHelper;
      }
    },
    BottomMessageContentHidden: {
      visibility: "hidden"
    }
  };
});
/**
 * Create a NavTopBar Wrapper that goes into a NavHorizontalBar Component
 */

var FormAnimatedWrapper = /*#__PURE__*/_react["default"].forwardRef(function FormAnimatedWrapper(props, ref) {
  var options = props.options,
      curvalue = props.curvalue,
      initialvalue = props.initialvalue,
      UpdateOptionsFromOutside = props.UpdateOptionsFromOutside,
      InputType = props.InputType,
      label = props.label,
      InputRef = props.InputRef,
      FormInputComponent = props.FormInputComponent,
      IsFocus = props.IsFocus,
      HasValue = props.HasValue,
      LabelScale = props.LabelScale,
      HasError = props.HasError,
      variant = props.variant,
      placeHolder = props.placeHolder,
      disabled = props.disabled,
      required = props.required,
      StyleBorderErrorFocusTrue = props.StyleBorderErrorFocusTrue,
      Colors = props.Colors,
      InputFontProp = props.InputFontProp,
      LabelStyle = props.LabelStyle,
      BorderStyle = props.BorderStyle,
      inputVerticalPadding = props.inputVerticalPadding,
      MultiSelect = props.MultiSelect;
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  })); // const [IsFocus, setIsFocus] = React.useState(false);
  // const [HasValue, setHasValue] = React.useState(false);
  // const [HasError, setHasError] = React.useState(false);

  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      LabelTransformY = _React$useState2[0],
      setLabelTransformY = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(null),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      InputMarginBottom = _React$useState4[0],
      setInputMarginBottom = _React$useState4[1];

  var _React$useState5 = _react["default"].useState({
    height: null,
    fontSize: null
  }),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      LegendSpanStyle = _React$useState6[0],
      setLegendSpanStyle = _React$useState6[1]; //Let's calculate the label Transform Y value based on the computed Input height


  var CalculateLabelTransform = _react["default"].useCallback(function () {
    if (InputRef) {
      if (InputRef.current && LabelRef.current) {
        var InputHeight = InputRef.current.getBoundingClientRect().height;
        var LabelHeight = LabelRef.current.getBoundingClientRect().height;
        var LegendHeight = parseFloat(LabelScale) * LabelHeight; //Checking what props to take for the fontSize

        var ThemeFontSize = theme.FormTextInput.InputFont.fontSize;
        var InputFontSizeFinal = InputFontProp.fontSize ? InputFontProp.fontSize : ThemeFontSize;
        var LegendFontSize = parseFloat(LabelScale) * parseFloat(InputFontSizeFinal); // const TformY = LegendHeight + parseInt(PaddingTop) + (InputHeight - LabelHeight) / 2;

        var TformY = LegendHeight + (InputHeight - LabelHeight) / 2;
        setLabelTransformY("".concat(TformY, "px"));
        var FinalLegStyle = {
          height: "".concat(LegendHeight, "px"),
          fontSize: "".concat(LegendFontSize, "px")
        };
        setLegendSpanStyle(FinalLegStyle);

        if (placeHolder) {
          var LegendHeightForMargin = LabelHeight;
          setInputMarginBottom("".concat(LegendHeightForMargin / 2, "px"));
        } else {
          setInputMarginBottom("".concat(LegendHeight / 2, "px"));
        }
      } else {
        console.log("ref not exisiting yet");
      }
    } else {
      //Select option -> no need for a ref, fixed outlined
      // const InputHeight = InputRef.current.getBoundingClientRect().height;
      // const PaddingTop = InputRef.current.style.paddingTop;
      var _LabelHeight = LabelRef.current.getBoundingClientRect().height;
      var _LegendHeight = _LabelHeight; // //Checking what props to take for the fontSize

      var _ThemeFontSize = theme.FormTextInput.InputFont.fontSize;

      var _InputFontSizeFinal = InputFontProp.fontSize ? InputFontProp.fontSize : _ThemeFontSize;

      var _LegendFontSize = parseFloat(LabelScale) * parseFloat(_InputFontSizeFinal); // // const TformY = LegendHeight + parseInt(PaddingTop) + (InputHeight - LabelHeight) / 2;
      // const TformY = LegendHeight + (InputHeight - LabelHeight) / 2;
      // setLabelTransformY(`${TformY}px`);


      var _FinalLegStyle = {
        height: "".concat(_LegendHeight, "px"),
        fontSize: "".concat(_LegendFontSize, "px")
      };
      setLegendSpanStyle(_FinalLegStyle);
      setInputMarginBottom("".concat(_LegendHeight / 2, "px"));
    }
  }, [InputRef, InputFontProp, LabelScale, theme, placeHolder]); //Calculating the Label transform position when mounting


  _react["default"].useEffect(function () {
    CalculateLabelTransform();
  }, [CalculateLabelTransform]);

  var LegendClass = classes.Legend;
  var FieldSetClass = (0, _clsx["default"])(variant === "outlined" ? classes.FieldSet : classes.FieldSetStandard, variant === "outlined" && classes.FieldSetOutlinedBorderEmpty);
  var LabelClass = (0, _clsx["default"])(classes.Label, classes.LabelEmpty, classes.InputFont);
  var InputClass = (0, _clsx["default"])(classes.Input, classes.InputColor);
  var LabelTransform; //Borderd for standard Input Type

  var FocusBorder;
  var HoverBorder;
  var ErrorBorder;
  var FinalFocusBorderStyle = {};

  if (variant !== "outlined") {
    var BorderColorFinal = Colors ? Colors.Focused ? Colors.Focused : null : null;
    var BorderStyleFinal = BorderStyle ? BorderStyle.Focused ? BorderStyle.Focused : null : null;

    if (BorderStyleFinal) {
      FinalFocusBorderStyle = {
        borderBottom: BorderStyleFinal
      };
    } else if (BorderColorFinal) {
      FinalFocusBorderStyle = {
        borderBottom: "2px solid ".concat(BorderColorFinal)
      };
    } else {
      FinalFocusBorderStyle = theme.FormTextInput.FieldSetBorderFocus;
    }
  }

  if (variant !== "outlined") {
    FocusBorder = (0, _clsx["default"])(classes.StandardInputBorder, classes.FocusBorderHidden);

    if (disabled === true) {
      //Disabled border
      FieldSetClass = (0, _clsx["default"])(FieldSetClass, classes.BorderDisabled);
    } else {
      if (HasError) {
        //Error border
        ErrorBorder = (0, _clsx["default"])(classes.StandardInputBorder, classes.ErrorBorder);
      } else {
        if (IsFocus) {
          //Focus Border
          FocusBorder = (0, _clsx["default"])(FocusBorder, classes.FocusBorderFocused);
        } else {
          if (HasValue) {
            //Filled Border
            HoverBorder = (0, _clsx["default"])(classes.StandardInputBorder, classes.HoverBorderHovered);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, classes.BorderFilled);
          } else {
            HoverBorder = (0, _clsx["default"])(classes.StandardInputBorder, classes.HoverBorderHovered);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, classes.BorderEmpty); //Empty Border
          }
        }
      }
    }
  }

  if (InputType === "Select") {
    if (disabled === true) {
      //When input is disabled
      LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
      LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelDisabled);
      FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderDisabled);
      InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorDisabled);
    } else {
      if (HasError) {
        //With Errors
        if (IsFocus) {
          if (StyleBorderErrorFocusTrue) {
            //Keep the border and Error Style the same as error style, just the input color is focus
            LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
            LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelError);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderError);
            InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFocus);
          } else {
            //Error and Focus Ignore Error while typing -> style = focus
            LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
            LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelFocus);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderFocus);
            InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFocus);
          }
        } else {
          //Error and has value -> Style is Error with label on top
          LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
          LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelError);
          FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderError);
          InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorError);
        }
      } else {
        if (IsFocus) {
          //Normal Focus, ignore the PlaceHolder ->  Label should be on top and style is Focused
          LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
          LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelFocus);
          FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderFocus);
          InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFocus);
        } else {
          //Not focused, and has a value -> Style is Filled
          LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
          LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelFilled);
          FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderFilled);
          InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFilled);
        }
      }
    }
  } else {
    if (disabled === true) {
      //When input is disabled
      if (HasValue) {
        //Disabled style with legend on top
        LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
        LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelDisabled);
        FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderDisabled);
        InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorDisabled);
      } else {
        if (placeHolder) {
          //Disabled style with legend on top
          //Disabled style with legend on top
          LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
          LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelDisabled);
          FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderDisabled);
          InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorDisabled);
        } else {
          //Disabled style with legend in the middle
          LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelDisabledEmpty);
          FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderDisabled);
          InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorDisabled);

          if (variant === "outlined") {
            LabelTransform = {
              transform: "scale(1) translate(12px, ".concat(LabelTransformY, ") translateX(0px) translateY(0px)")
            };
          } else {
            LabelTransform = {
              transform: "scale(1) translate(0px, ".concat(LabelTransformY, ") translateX(0px) translateY(0px)")
            };
          }
        }
      }
    } else {
      if (HasError) {
        //With Errors
        if (IsFocus) {
          if (StyleBorderErrorFocusTrue) {
            //Keep the border and Error Style the same as error style, just the input color is focus
            LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
            LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelError);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderError);
            InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFocus);
          } else {
            //Error and Focus Ignore Error while typing -> style = focus
            LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
            LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelFocus);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderFocus);
            InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFocus);
          }
        } else {
          if (HasValue) {
            //Error and has value -> Style is Error with label on top
            LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
            LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelError);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderError);
            InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorError);
          } else {
            if (placeHolder) {
              //Error ,no value but placeHolder -> Style is Error with label on top
              LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
              LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelError);
              FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderError);
              InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorError);
            } else {
              //Error, no vlaue and no placeholder -> style is Error empty
              LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelErrorEmpty);
              FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderError);
              InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorError);

              if (variant === "outlined") {
                LabelTransform = {
                  transform: "scale(1) translate(12px, ".concat(LabelTransformY, ") translateX(0px) translateY(0px)")
                };
              } else {
                LabelTransform = {
                  transform: "scale(1) translate(0px, ".concat(LabelTransformY, ") translateX(0px) translateY(0px)")
                };
              }
            }
          }
        }
      } else if (placeHolder) {
        //No ERRORS && PlaceHolder
        if (IsFocus) {
          //Normal Focus, ignore the PlaceHolder ->  Label should be on top and style is Focused
          LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
          LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelFocus);
          FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderFocus);
          InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFocus);
        } else {
          if (HasValue) {
            //Not focused, and has a value -> Style is Filled
            LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
            LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelFilled);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderFilled);
            InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFilled);
          } else {
            //When a placeHolder was passed and not Focused ->  Label should be on top and style is Empty
            LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
            LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelPlaceHolderEmpty);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderEmpty);
            InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorEmpty);
          }
        }
      } else {
        //No ERRORS && No PlaceHolder
        if (IsFocus) {
          //When Focused -> Label should be on top and style is Focused
          LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
          LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelFocus);
          FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderFocus);
          InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFocus);
        } else {
          if (HasValue) {
            //Not focused, and has a value -> Style is Filled
            LegendClass = (0, _clsx["default"])(classes.Legend, classes.LegendTop);
            LabelClass = (0, _clsx["default"])(LabelClass, classes.LabelFilled);
            FieldSetClass = (0, _clsx["default"])(FieldSetClass, variant === "outlined" && classes.FieldSetOutlinedBorderFilled);
            InputClass = (0, _clsx["default"])(classes.Input, classes.InputColorFilled);
          } else {
            //Default Empty Style
            if (variant === "outlined") {
              LabelTransform = {
                transform: "scale(1) translate(12px, ".concat(LabelTransformY, ") translateX(0px) translateY(0px)")
              };
            } else {
              LabelTransform = {
                transform: "scale(1) translate(0px, ".concat(LabelTransformY, ") translateX(0px) translateY(0px)")
              };
            }
          }
        }
      }
    }
  }

  var LabelRef = _react["default"].useRef(null); //Needs to be inline for calculation purposes


  var FinalInputPadding;

  if (inputVerticalPadding) {
    if (InputType === "Select") {
      if (MultiSelect) {
        FinalInputPadding = "".concat(inputVerticalPadding, " 0px ").concat(inputVerticalPadding, " 8px");
      } else {
        FinalInputPadding = "".concat(inputVerticalPadding, " 0px ").concat(inputVerticalPadding, " 11px");
      }
    } else {
      if (variant === "outlined") {
        FinalInputPadding = "".concat(inputVerticalPadding, " 13px ").concat(inputVerticalPadding, " 5px");
      } else {
        FinalInputPadding = "".concat(inputVerticalPadding, " 0px ").concat(inputVerticalPadding, " 0px");
      }
    }
  } else {
    if (InputType === "Select") {
      if (MultiSelect) {
        FinalInputPadding = "".concat(theme.FormTextInput.Input.paddingTop, " 0px ").concat(theme.FormTextInput.Input.paddingBottom, " 8px");
      } else {
        FinalInputPadding = "".concat(theme.FormTextInput.Input.paddingTop, " 0px ").concat(theme.FormTextInput.Input.paddingBottom, " 11px");
      }
    } else {
      if (variant === "outlined") {
        FinalInputPadding = "".concat(theme.FormTextInput.Input.paddingTop, " 13px ").concat(theme.FormTextInput.Input.paddingBottom, " 5px");
      } else {
        FinalInputPadding = "0px";
      }
    }
  }

  var FinalInputFonts = {
    fontSize: InputFontProp.fontSize ? InputFontProp.fontSize : theme.FormTextInput.InputFont.fontSize,
    fontFamily: InputFontProp.fontFamily ? InputFontProp.fontFamily : theme.FormTextInput.InputFont.fontFamily,
    fontWeight: InputFontProp.fontWeight ? InputFontProp.fontWeight : theme.FormTextInput.InputFont.fontWeight
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: FieldSetClass,
    style: (0, _extends2["default"])({}, Lockedstyles.FieldSet, LockedstylesWithProps(props).FieldSet)
  }, /*#__PURE__*/_react["default"].createElement("legend", {
    className: LegendClass,
    style: {
      height: LegendSpanStyle.height,
      fontSize: LegendSpanStyle.fontSize
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.LegendSpan
  }, label), required && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.LegendSpan
  }, "*")), /*#__PURE__*/_react["default"].createElement("div", {
    ref: LabelRef,
    className: LabelClass,
    style: LabelTransform
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.LabelSpan,
    style: {
      padding: variant === "outlined" ? null : "0px",
      fontSize: InputFontProp.fontSize ? InputFontProp.fontSize : theme.FormTextInput.InputFont.fontSize,
      fontFamily: InputFontProp.fontFamily ? InputFontProp.fontFamily : theme.FormTextInput.InputFont.fontFamily,
      fontWeight: InputFontProp.fontWeight ? InputFontProp.fontWeight : theme.FormTextInput.InputFont.fontWeight
    }
  }, label), required && /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.LabelSpan,
    style: {
      fontSize: InputFontProp.fontSize ? InputFontProp.fontSize : theme.FormTextInput.InputFont.fontSize,
      fontFamily: InputFontProp.fontFamily ? InputFontProp.fontFamily : theme.FormTextInput.InputFont.fontFamily,
      fontWeight: InputFontProp.fontWeight ? InputFontProp.fontWeight : theme.FormTextInput.InputFont.fontWeight
    }
  }, "*")), FormInputComponent({
    InputClass: InputClass,
    InputMarginBottom: InputMarginBottom,
    FinalInputPadding: FinalInputPadding,
    FinalInputFonts: FinalInputFonts,
    options: options,
    curvalue: curvalue,
    initialvalue: initialvalue,
    UpdateOptionsFromOutside: UpdateOptionsFromOutside
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: FocusBorder,
    style: FinalFocusBorderStyle,
    content: "\"\""
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: HoverBorder,
    content: "\"\""
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: ErrorBorder,
    content: "\"\""
  }));
});

FormAnimatedWrapper.defaultProps = {
  InputType: "Input",
  variant: "outlined",
  label: "Field Label",
  InputRef: null,
  FormInputComponent: null,
  required: false,
  placeHolder: null,
  readOnly: false,
  disabled: false,
  LabelScale: "0.75",
  //Range is 0.75 - 0.85 otherwise fonts will crack
  StyleBorderErrorFocusTrue: true,
  Colors: {
    Empty: null,
    Filled: null,
    Error: null,
    Focused: null,
    Disabled: null
  },
  InputFontProp: {
    fontSize: null,
    fontFamily: null,
    fontWeight: null
  },
  inputVerticalPadding: null,
  BorderStyle: {
    Empty: null,
    Focused: null,
    Error: null,
    Disabled: null,
    BoderRadius: null
  },
  HelperStyle: {
    fontFamily: null,
    fontSize: null,
    marginTop: null,
    color: null
  },
  ErrorStyle: {
    color: null
  },
  LabelStyle: {
    Empty: null,
    Filled: null,
    Focused: null,
    Disabled: null,
    Error: null
  },
  InputStyle: {
    Empty: null,
    Filled: null,
    Focused: null,
    Disabled: null,
    Error: null
  },
  WithEmptyStyle: false
};
process.env.NODE_ENV !== "production" ? FormAnimatedWrapper.propTypes = {
  /**
   * FormInputComponent : the component to pass inside
   */
  FormInputComponent: _propTypes["default"].any,

  /**
   * InputRef : Required ref of the input to calcuate the sizes
   */
  InputRef: _propTypes["default"].any,

  /**
   * InputType : Input, Select. Defines the behaviors of the container and the syle to harmonize the sizes between the
   * different components
   */
  InputType: _propTypes["default"].string,

  /**
   * variant: outlined, standard
   */
  variant: _propTypes["default"].string,

  /**
   * input label
   */
  label: _propTypes["default"].string,

  /**
   * placeHolder value
   */
  placeHolder: _propTypes["default"].string,

  /**
   * required
   */
  required: _propTypes["default"].bool,

  /**
   * readOnly
   */
  readOnly: _propTypes["default"].bool,

  /**
   * disabled
   */
  disabled: _propTypes["default"].bool,

  /**
   * LabelScale : 0,75. Range is between 0.75 and 0.85, otherwise the text effect will not work
   */
  LabelScale: _propTypes["default"].string,

  /**
   * StyleBorderErrorFocusTrue : default is true
   * If true then the color of the input is focused when focused otherwise the input color is error color
   */
  StyleBorderErrorFocusTrue: _propTypes["default"].bool,
  Colors: _propTypes["default"].object,

  /**
   * InputFontProp: {fontSize: null, fontFamily: null, fontWeight: null},
   * Fonts for the label and the input
   */
  InputFontProp: _propTypes["default"].object,

  /**
   * LabelStyle: {Empty: null, Filled: null, Focused: null, Disabled: null, Error: null},
   * Customize the label (will override Colors)
   */
  LabelStyle: _propTypes["default"].object,

  /**
   * InputStyle: {Empty: null, Filled: null, Focused: null, Disabled: null, Error: null}
   * Customize the Input (will override Colors)
   */
  InputStyle: _propTypes["default"].object,

  /**
   * BorderStyle: {Empty: "1px solid grey", Focused: "1px solid grey", Error: "1px solid grey", Disabled: null, BoderRadius: "2px"},
   */
  BorderStyle: _propTypes["default"].object,

  /**
   * HelperStyle: {fontFamily: null, FontSize: null, marginTop: null, color: null},
   */
  HelperStyle: _propTypes["default"].object,

  /**
   * ErrorStyle: {fontFamily: "roboto", fontSize: "14px", marginTop: "2px", color: "red"},
   */
  ErrorStyle: _propTypes["default"].object,

  /**
   * Change the vertical padding of the input
   * inputVerticalPadding: "2px"
   */
  inputVerticalPadding: _propTypes["default"].string,

  /**
   * Default : false
   * When using the standard theme, when false -> Empty style = Filled Style when true Empty style is applied
   */
  WithEmptyStyle: _propTypes["default"].bool
} : void 0;
var _default = FormAnimatedWrapper;
exports["default"] = _default;